var SliderManager = function($){
    var $this = this;

    $this.positions = function(){
        var winh = $(window).height();
        var topbar = $('#topbar').outerHeight();
        var topbarMob = $('.barmob .topbar').outerHeight();
        var slideH = winh - topbar;
        var slideHMob = winh - topbarMob;

        $('.slideshowck_slide, .camera_fakehover, .moduletable_slide, .custom_fotosfondo,  .custom_fotosfondo img').css('height',slideH);
        $('.mobile .slideshowck_slide, .camera_fakehover, .mobile #start, .mobile .moduletable_slide, .mobile .custom_fotosfondo, .mobile .custom_fotosfondo img').css('height',slideHMob);
    };
};